//function navAccordion() {
//     if (Modernizr.mq('only screen and (min-width: 768px)')) {
//         $('.nav--tertiary .menu-item-has-children').unbind('click');
//         $('.nav--tertiary .sub-menu').removeAttr('style');
//     } else if (Modernizr.mq('only screen and (max-width: 767px)')) {
//         $('.nav--tertiary .menu-item-has-children > a').click(function(e){
//          e.preventDefault();
//          $(this).next('.sub-menu').slideToggle();
//          $(this).toggleClass('current-menu-item');
//         });
//     }
// Moved out of function and into doc ready because footer menu on mobile kept opening and closing again
//}

function showFilter() {
    if (Modernizr.mq('only screen and (min-width: 1200px)')) {
        $('.taxonomy__sort .js-toggle-trigger').trigger('click');
    } else if (Modernizr.mq('only screen and (max-width: 767px)')) {
        $('.facet .js-toggle-trigger').unbind('click');
        $('.facet .toggle__body').show();
    }
}

function accordion() {
    $('body').on('click', '.js-accordion-toggle', function (e) {
        e.preventDefault();
        var accordion_id = $(this).data('target');
        if ($(this).parent().hasClass('accordion__item--open')) { // If the accordion is already open
            $('.accordion__item').removeClass('accordion__item--open');
            $('.accordion__item__content').slideUp();
            $(this).parent().removeClass('accordion__item--open');
            $('#' + accordion_id).slideUp();
        } else { // If the accordion is not open
            $('.accordion__item').removeClass('accordion__item--open');
            $('.accordion__item__content').slideUp();
            $(this).parent().addClass('accordion__item--open');
            $('#' + accordion_id).slideDown();
        }
    });
}

function initMatchHeight() {
    // Equal Heights

    $('.js-match-height').matchHeight();

    $('.related .card__item').matchHeight();

    $('.gfield').matchHeight({
        property: 'min-height'
    });
}

jQuery(document).ready(function ($) {

    /*------------------------------------*\
        $FUNCTIONS
    \*------------------------------------*/

    if (Modernizr.mq('only screen and (max-width: 768px)')) {
        $('.nav--tertiary .menu-item-has-children > a').click(function (e) {
            e.preventDefault();
            $(this).next('.sub-menu').slideToggle();
            $(this).toggleClass('current-menu-item');
        });
    }

    /*------------------------------------*\
        $SLICK SLIDER
    \*------------------------------------*/

    // Global settings

    var slick_previous = '<a class="slick-arrow--previous"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.1381 3.13814L6.27627 8.00001L11.1381 12.8619C11.3985 13.1222 11.3985 13.5443 11.1381 13.8047C10.8778 14.065 10.4557 14.065 10.1953 13.8047L4.86199 8.47136C4.60163 8.211 4.60163 7.7889 4.86199 7.52854L10.1953 2.19521C10.4557 1.93485 10.8778 1.93485 11.1381 2.19521C11.3985 2.45557 11.3985 2.87766 11.1381 3.13802V3.13814Z" fill="currentColor"/></svg></a>';
    var slick_next = '<a class="slick-arrow--next"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.86187 3.13814L9.72373 8.00001L4.86187 12.8619C4.60151 13.1222 4.60151 13.5443 4.86187 13.8047C5.12223 14.065 5.54432 14.065 5.80468 13.8047L11.138 8.47136C11.3984 8.211 11.3984 7.7889 11.138 7.52854L5.80468 2.19521C5.54432 1.93485 5.12223 1.93485 4.86187 2.19521C4.60151 2.45557 4.60151 2.87766 4.86187 3.13802V3.13814Z" fill="currentColor"/></svg></a>';
    var slick_previous_white = '<a class="slick-arrow--previous"><svg><use xlink:href="#arrow-left-white"/></svg></a>';
    var slick_next_white = '<a class="slick-arrow--next"><svg><use xlink:href="#arrow-right-white"/></svg></a>';

    // Slick single

    var A = $('.hero-slider .hero__item__subheading');
    var B = $('.hero-slider .hero__item__heading');
    var C = $('.hero-slider .hero__item__caption');
    var D = $('.hero-slider .hero__item__button');
    var tlSlider = new TimelineMax({ paused: true });

    tlSlider.to(A, 0.25, { opacity: 1, ease: Power0.easeIn });
    tlSlider.to(B, 0.25, { opacity: 1, ease: Power0.easeIn });
    tlSlider.to(C, 0.25, { opacity: 1, ease: Power0.easeIn });
    tlSlider.to(D, 0.25, { opacity: 1, ease: Power0.easeIn });

    $('.js-slick-single').on('init', function(slick) {
        tlSlider.play();
    });

    $('.js-slick-single').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        prevArrow: slick_previous_white,
        nextArrow: slick_next_white,
        appendArrows: '.js-slick-nav',
        dots: true,
        speed: 1200,
        fade: true,
        cssEase: 'ease-in-out',
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false
    });

    // Before change

    $('.js-slick-single').on('beforeChange', function(slick, currentSlide, nextSlide) {
        tlSlider.pause(0);
        setTimeout(function(){
            tlSlider.pause(0);
        }, 100);
    });

    // After change

    $('.js-slick-single').on('afterChange', function(slick, currentSlide) {
        tlSlider.restart();
    });

    // Slick Text

    var A = ('.js-slick-text .list--star li');
    var tlStar = new TimelineLite({ paused: true });
    tlStar.staggerTo(A, 0.6, { opacity: 1 }, 0.1);

    $('.js-slick-text').on('init', function (slick) {
        tlStar.play();
    });

    $('.js-slick-text').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        prevArrow: slick_previous,
        nextArrow: slick_next,
        dots: false,
        speed: 600,
        cssEase: 'ease-in-out',
        autoplay: true,
        autoplaySpeed: 5000,
    });

    $('.js-slick-text').on('beforeChange', function (slick, currentSlide, nextSlide) {
        $('.js-slick-text .list--star li').removeAttr('style');
    });

    $('.js-slick-text').on('afterChange', function (slick, currentSlide) {
        var $currentSlide = $('.js-slick-text .slick-current');
        var $star = $currentSlide.find('.list--star li');
        slideAnimation = new TimelineLite();
        slideAnimation.staggerTo($star, 0.6, { opacity: 1 }, 0.1);
    });

    // Slick Instagram

    $('.js-slick-instagram').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        prevArrow: slick_previous,
        nextArrow: slick_next,
        dots: false,
        speed: 600,
        cssEase: 'ease-in-out',
        autoplay: true,
        autoplaySpeed: 5000,
    });

    // Slick mobile only

    $('.js-slick-small').slick({
        slidesToShow: 10, // High number so it won't trigger on desktop
        slidesToScroll: 10, // High number so it won't trigger on desktop
        infinite: true,
        arrows: true,
        prevArrow: slick_previous,
        nextArrow: slick_next,
        dots: false,
        responsive: [{
            breakpoint: 2600,
            settings: "unslick"
        },
        {
            breakpoint: 699,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
            }
        }
        ]
    });

    // Slick Thumbnail Gallery

    $('.js-slick-thumb').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        asNavFor: '.js-slick-thumb-nav'
    });

    $('.js-slick-thumb-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        asNavFor: '.js-slick-thumb',
        focusOnSelect: true
    });

    // Slick Card

    $('.js-slick-card').on('init', function (slick) {
        $('.js-slick-card .card__item__content').matchHeight();
    });

    $('.js-slick-card').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        prevArrow: slick_previous,
        nextArrow: slick_next,
        dots: false,
        lazyLoad: 'ondemand',
        responsive: [{
            breakpoint: 1199,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 699,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                adaptiveHeight: true
            }
        }
        ]
    });

    // Slick - Promo

    $('.js-slick-promo').on('init', function(slick) {
        $('.js-slick-promo').removeClass('is-loading');
    });

    $('.js-slick-promo').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        adaptiveHeight: true
    });   

    // Mega Menu - Toggle

    $(".nav--primary .js-mega-menu > a").click(function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        var mega_menu = $(this).attr("data-mega-menu");

        console.log('Menu Target: ' + target);
        console.log('Mega Menu: ' + mega_menu);

        if ($(this).parent('li').hasClass("is-active")) {
            window.location = target;
        } else {
            $(".nav--primary li").removeClass("is-active");
            $(this).parent('li').addClass("is-active");
            $(".nav--mega").removeClass("is-active is-animated");
            $("#mega-menu-" + mega_menu).addClass("is-active is-animated");
        }
    });

    // Mega Menu - Sub Menu

    $('.nav--mega .sub-menu a, .offscreen__nav .sub-menu a').click(function () {
        var newURL = $(this).attr('href');
        var newURLBase = newURL.split('#')[0];
        var currentURL = window.location.toString().split('#')[0];
        // If URL base is the same
        if (newURLBase === currentURL) {
            window.location.href = newURL;
            location.reload();
        }
    });

    // Mega Menu - Close

    $('.js-mega-menu-close').click(function (e) {
        var target = $(this).data('target');
        $('#' + target).removeClass('is-active is-animated');
        $('.nav--primary .is-active').removeClass('current-menu-item');
        $(".nav--primary li").removeClass("is-active");
    });

    // Mega Menu - Image

    var blazyMenu = new Blazy({
        container: '.mega-menu',
        success: function (element) {
            $(element).prev('.spinner').fadeOut().remove();
        }
    });

    // Tablet (squares menu)
    $(".nav--square .js-mega-menu > a").click(function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        // Active state for tabs
        $(".nav--square li").removeClass("current-menu-item");
        $(this).parent('li').addClass("current-menu-item");
        //$(target).addClass('mega-menu--active');
        // Active state for Tabs Content
        $(".mega-menu > .mega-menu--active").removeClass("mega-menu--active").slideUp();
        $(target).slideDown().addClass("mega-menu--active");
    });

    // Open offscreen menu

    $('.js-offscreen-toggle').click(function (e) {
        e.preventDefault();
        var offscreenTarget = $(this).find('a').attr('href');
        $('.site-overlay').addClass('site-overlay--active');
        $('.offscreen--content').addClass('offscreen--open');
        $('body').addClass('body--offscreen-open');
        $('.offscreen__item').hide();
        $(offscreenTarget).show();
        $('.offscreen--content .spinner').fadeOut().remove();
    });

    // Open from URL bar

    var hash = window.location.hash;
    if (hash.length) { // If there is a hash in the URL
        if (hash == '#user-login' || hash == '#user-trade') { // Only if hash is for logins
            $('a[href="' + hash + '"]').trigger('click');
        }
        // $('.site-overlay').addClass('site-overlay--active');
        // $('.offscreen--content').addClass('offscreen--open');
        // $('body').addClass('body--offscreen-open');
        // $('.offscreen__item').hide();
        // $(hash).show();
        // $('.offscreen--content .spinner').fadeOut().remove();
    }

    // Close offscreen menu

    $('.js-offscreen-close').click(function (e) {
        e.preventDefault();
        $('.site-overlay').removeClass('site-overlay--active');
        $('.offscreen--content').removeClass('offscreen--open');
        $('body').removeClass('body--offscreen-open');
    });

    // Toggle offscreen nav

    $('.js-nav-toggle').click(function (e) {
        e.preventDefault();
        $('.hamburger').toggleClass('hamburger--active');
        $('.site-overlay').toggleClass('site-overlay--active');
        $('.offscreen--nav').toggleClass('offscreen--open');
        $('body').toggleClass('body--offscreen-open');
    });

    // Toggle Search

    $('.js-search-toggle').click(function (e) {
        e.preventDefault();
        $('.form-panel').slideToggle().toggleClass('is-active');
        $('.form-panel #s').focus();

        // Close mega menu if open
        if ($('.mega-menu').hasClass('mega-menu--active')) {
            $('.mega-menu').slideUp().removeClass('mega-menu--active');
            $('.nav--primary li').removeClass('mega-menu--active');
            $('.mega-menu ul li').removeClass('current-menu-item');
        }
        // Close offscreen menu if open
        if ($('.offscreen--nav').hasClass('offscreen--open')) {
            $('.hamburger').removeClass('hamburger--active');
            $('.site-overlay').removeClass('site-overlay--active');
            $('.offscreen--nav').removeClass('offscreen--open');
            $('body').removeClass('body--offscreen-open');
        }
    });
    
    // Drawer menu

    $('.nav--drawer .menu-item-has-children > a').click(function(e){
        e.preventDefault();
        var parentTitle = $(this).text();
        var submenu = $(this).next('.sub-menu');
        $('#nav-drawer-sub-menu').addClass('is-active');
        $('#nav-drawer-sub-menu .nav__title').text(parentTitle);
        $('#nav-drawer-sub-menu .nav__menu').append(submenu.clone());
    });

    $('.js-nav-drawer-back').click(function(e){
        $('#nav-drawer-sub-menu').removeClass('is-active');
        $('#nav-drawer-sub-menu .nav__menu').empty();
    });

    // Mobile sub menu 

    $('.offscreen--nav .nav--primary > li > a').append('<span class="toggle"></span>');

    $('.offscreen--nav .nav--primary .menu-item-has-children > a').click(function (e) {
        e.preventDefault();
        $(this).parent('li').toggleClass('is-active');
        $(this).next('.sub-menu').slideToggle().toggleClass('is-active');
    });

    // Close nav on anchor click

    $('.nav-mobile a[href*="#"]').click(function (event) {
        $('.js-nav-toggle').trigger('click');
    });

    // Smooth scroll for anchor links

    $('.js-link-anchor, .js-link-anchor a').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
                return false;
            }
        }
    });

    /*------------------------------------*\
        $POPUPS
    \*------------------------------------*/

    // Magnific Popup - Standard

    $('.js-magnific-popup').magnificPopup({
        type: 'inline',
        closeBtnInside: true,
        midClick: true,
    });

    // Magnific Popup - Location

    $('.js-magnific-location').magnificPopup({
        type: 'inline',
        closeBtnInside: true,
        midClick: true,
        callbacks: {
            close: function () {
                if (!Cookies.get('cookie-location')) { // If no cookie is set
                    var bodyLocation = $('body').attr('data-location'); // Set location
                    Cookies.set('cookie-location', bodyLocation, { 
                        expires: 30,
                        sameSite: 'lax'
                    });
                }
            }
        }
    });

    // Magnific Popup - Video

    $('.js-magnific-video').magnificPopup({
        type: 'inline',
        midClick: true,
        callbacks: {
            open: function () {
                // Play video on open
                $(this.content).find('video')[0].play();
                var p = $(this.content).find('video')[0].player;
                p.setPlayerSize();
                p.setControlsSize();
            },
            close: function () {
                // Reset video on close
                $(this.content).find('video')[0].load();
            }
        }
    });

    // Magnific Popup with Cookie.js

    if (!Cookies.get('cookie-first')) {
        Cookies.set('cookie-first', 'true', { expires: 30 });
    } else if (Cookies.get('cookie-first')) {
        if (!Cookies.get('cookie-subscribe')) {
            if (Modernizr.mq('only screen and (min-width: 1200px)')) { // If screen is wider than 1200px
                setTimeout(function () {
                    $('a[href="#popup-subscribe"]').trigger('click');
                    Cookies.set('cookie-subscribe', 'true', { expires: 30 });
                }, 5000);
            }
        }
    }

    // Magnific Popup - AJAX

    function slickInitAJAX() {
        $('.js-slick-diagram').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            prevArrow: slick_previous,
            nextArrow: slick_next,
            dots: false,
            speed: 600,
            cssEase: 'ease-in-out',
            autoplay: false
        });
    }

    slickInitAJAX();

    $(document).magnificPopup({
        delegate: '.js-magnific-ajax',
        type: 'ajax',
        closeBtnInside: true,
        closeOnContentClick: false,
        closeOnBgClick: false,
        tLoading: '<div class="spinner"></div>',
        callbacks: {
            ajaxContentAdded: function () {
                slickInitAJAX();
            }
        }
    });

    /*------------------------------------*\
        $SEARCH
    \*------------------------------------*/

    $('#s').focus(function () {
        $(this).parent('form').addClass('form--search--active');
    });

    $('#s').blur(function () {
        $(this).parent('form').removeClass('form--search--active');
    });

    /*------------------------------------*\
        $LAYOUT
    \*------------------------------------*/

    initMatchHeight();

    /*------------------------------------*\
        $MEDIA
    \*------------------------------------*/

    // Responsive videos

    $('.js-fitvids').fitVids();

    // Lazy Loading images

    var bLazy = new Blazy({
        selector: '.b-lazy',
        loadInvisible: true,
        offset: 200,
        success: function (element) {
            $(element).prev('.spinner').fadeOut().remove();
        }
    });

    $('.gfield_select, .variations_form select:not([data-notdk="true"]), .woocommerce-ordering select, .tinvwl-table-manage-list select, #calc-container select').dropkick({
        mobile: true
    });

    // Add data to variation dropdown 

    $('#pa_size option').each(function(){
        if($(this).val() == 'double-roll' || $(this).val() == 'roll' || $(this).val() == 'two-roll-set') {
            $(this).addClass('is-wallpaper-roll'); 
        }
    });

    // Checkboxradio

    function initCBR() {
        // Add data to tearsheet button
            var currrentURL = $('.dkpdf-button').attr('href');
            $('.dkpdf-button').attr('data-href', currrentURL);
        // Radio buttons
        $('.cbradio').each(function(){
            var size = $(this).data('size');
            $(this).checkboxradio({
                icon: false,
                classes: {
                    "ui-checkboxradio-label": "ui-checkboxradio-" + size,
                }
            }).on('change', function(e) {
                // Update select element
                var parent = $(this).data('parent');
                // Size changed
                if($(this).data('parent') == '_attribute_pa_size') {
                    $('[name="attribute_pa_size"]').val(e.target.value).trigger('change');
                }
                // Type changed
                if($(this).data('parent') == '_attribute_pa_material-type') {
                     
                    var targetValue = e.target.value;
                    var variationID = $(this).data('variation');
                    console.log('Product material type changed to ' + targetValue);

                    // Reset select elements
                        
                    //     $('#pa_base').prop('selectedIndex', 0).trigger('change');
                        
                    //     // var firstEnabledOption = $('#pa_size').children('.enabled');
                    //     // console.log('#pa_size firstEnabledOption: ' + firstEnabledOption.val());
                                                
                    // // Change data attribute
                    //     $('.product').attr('data-material-type', targetValue);
                    // // Update select value
                    //     $('#pa_material-type').prop('selectedIndex', 1).trigger('change');    
                    //     $('#pa_material-type').val(targetValue).trigger('change');
                        $('#pa_size').prop('selectedIndex', 0).trigger('change');
                        $('#pa_material-type').prop('selectedIndex', 0).trigger('change');

                        setTimeout(function() {
                            var typeVal = $('#pa_material-type').val();
                            console.log('Variations updated to ' + typeVal);
                            if(targetValue == 'vinyl') { // Vinyl
                                $('#pa_size').val('yard').trigger('change');
                                $('#pa_material-type').val('vinyl').trigger('change');
                                $('#pa_size option').removeClass('enabled');
                                $('#pa_size option[value="yard"], #pa_size option[value="vinyl-sample"]').addClass('enabled');
                            } else { // Wallpaper
                                var wallpaperOption = $('#pa_size .is-wallpaper-roll').index();
                                console.log('wallpaperOption index: ' + wallpaperOption);
                                $('#pa_size').prop('selectedIndex', wallpaperOption).trigger('change');
                                $('#pa_material-type').val('wallpaper').trigger('change');
                                $('#pa_size option').addClass('enabled');
                                $('#pa_size option[value="yard"], #pa_size option[value="vinyl-sample"]').removeClass('enabled');
                            }
                            var newSize = $('#pa_size').val();
                            $('.row--pa_size .cbradio').prop('checked',false).checkboxradio('refresh');
                            $('#_attribute_pa_size-' + newSize).prop('checked',true).checkboxradio('refresh'); 
                            console.log('newSize: ' + newSize);
                             // 1. Hide variation options
                            $('.row--pa_size .list--cbr li').hide();
                            // 2. Get a list of enabled options
                            
                            $('#pa_size option.enabled').each(function(){
                                var optionId = $(this).val();
                                $('.list--cbr li[data-value="' + optionId + '"]').show().addClass('is-selectable');
                                console.log('optionID: ' + optionId);
                            });  
                            if($('#pa_size .enabled').length) {
                                var firstEnabledOption = $('#pa_size').children('.enabled').val();
                            } else {
                                var firstEnabledOption = $('#pa_size').val();
                            }
                        }, 500);
                                              
                    // Update 'Fabric Base' 
                        if($('#pa_base').length) {
                            var DKFabricBase = new Dropkick('#pa_base');
                            DKFabricBase.refresh();
                            if(targetValue == 'fabric') {
                                $('.row--pa_base').show();
                            } else {
                                $('.row--pa_base').hide();
                            }
                        }
                    // Update tearsheet URL
                        updateTearsheet(targetValue,variationID);                        
                }
            });
        });
        // Add 'button'
        if($('body').hasClass('logged-in-trade') || $('body').hasClass('logged-in-wholesale')) {
            $('.single-product .product_cat-designer-wallpaper .variations__field li[data-value="vinyl"]').append('<div class="button--fake"><div class="button__secondary">Trade/<br> wholesale<br> only</div></div>');
        }        
        // Add to cart - check selected material type
        if($('#pa_material-type').length) {
            var initialMaterialType = $('#pa_material-type').val();
            console.log('initialMaterialType: ' + initialMaterialType);
            if(initialMaterialType == 'vinyl') {
                $('.row--pa_size .list--cbr li').hide();
                $('.list--cbr li[data-value="yard"]').show().addClass('is-selectable');
                $('.list--cbr li[data-value="vinyl-sample"]').show().addClass('is-selectable');
            }
        } 
    }

    initCBR();

    // Only display available sizes

    // $('body').on('woocommerce_update_variation_values', function () {
    //     // 1. Hide variation options
    //     $('.row--pa_size .list--cbr li').hide();
    //     // 2. Get a list of enabled options
    //     $('#pa_size option.enabled').each(function () {
    //         var optionId = $(this).val();
    //         $('.list--cbr li[data-value="' + optionId + '"]').show().addClass('is-selectable');
    //     });
    // });

    // Sync CBR with select element

    // $('#pa_material-type,#pa_size').on('change', function () {
    //     var currentValue = $(this).val();
    //     var thisId = $(this).attr('id');
    // });

    // Trigger vinyl change from URL

    // var searchParams = new URLSearchParams(window.location.search);
    // if(searchParams.has('attribute_pa_material-type')) {
    //     var param = searchParams.get('attribute_pa_material-type');
    //     if(param == 'vinyl') {
    //         // Update page
    //         $('body').trigger('woocommerce_update_variation_values');
    //         $('#_attribute_pa_material-type-vinyl').trigger('change');
    //     }
    // }

    function updateTearsheet(materialType, variationID) {
        var tearsheetURL = $('.dkpdf-button').data('href');
        var customTearsheetURL = tearsheetURL + '&product_type=' + materialType + '&variation_id=' + variationID;
        $('.dkpdf-button').attr('href', customTearsheetURL);
    }

    // Trigger after add to cart

    $('body').on('show_variation', function (event, variation) {
        // Update tearsheet
        if ($('#pa_material-type').length) {
            var selectedMaterial = $('#pa_material-type').val();
            var variationID = variation.variation_id;
            // Update product data
            $('.product').attr('data-material-type', selectedMaterial);
        } else {
            var selectedMaterial = $('.product').data('material-type');
            var variationID = variation.variation_id;
        }
        updateTearsheet(selectedMaterial, variationID);
        // Update 'Download Image' link        
            var downloadLink = $('.woocommerce-product-gallery__wrapper div').first().find('a').attr('href');
            getDownloadLink(downloadLink);
        // AfterPay/ClearPay
        if ($('.is-price afterpay-placement').length) {
            if ($('body').hasClass('logged-in-trade') || $('body').hasClass('logged-in-wholesale')) {
                var variationPrice = variation.wholesale_price;
            } else {
                var variationPrice = variation.display_price;
            }
            $('.is-price afterpay-placement').attr('data-amount', variationPrice);
            $('.product__payment').empty().attr('data-updated', true);
            $('.is-price afterpay-placement').clone().prependTo('.product__payment');
        }
    });

    /*------------------------------------*\
        $OTHER
    \*------------------------------------*/

    // $('.js-chat-toggle').click(function(e){
    //  e.preventDefault();
    //  $('.chat').toggleClass('chat--inactive');
    // });

    $('.purechat-button-expand').click(function (e) {
        e.preventDefault();
    });

    $('.gform_wrapper form').submit(function () {
        $(this).parent('.gform_wrapper').addClass('form--loading');
    });

    // Lettering

    // $('.heading--line, .gsection_title').lettering('lines');
    $('.nav--tab--icon .subheading').lettering('lines');

    // Accordion

    accordion();

    // Toggle

    $('.js-toggle-trigger').click(function (e) {
        e.preventDefault();
        var toggle_id = $(this).data('target');
        var toggle_transition = $(this).data('transition');
        $('#' + toggle_id).toggleClass('toggle__body--active');
        if (toggle_transition == 'slide') {
            $('#' + toggle_id).slideToggle();
        }
        $(this).toggleClass('toggle__heading--active');
    });

    // Tab to accordion

    $('.tab__item').hide();
    $('.tab__item:first').show();

    //  Tab navigation

    $(".nav--tab a").click(function (e) {
        e.preventDefault();
        $(".tab__item").hide();
        var activeTab = $(this).attr("href");
        $(activeTab).fadeIn();

        $(".nav--tab li").removeClass("active");
        $(this).parent('li').addClass("active");

        $(".tab__item__heading").removeClass("active");
        $(".tab__item__heading[href^='" + activeTab + "']").addClass("active");

    });

    // Accordion navigation

    $('.tab__item__heading a').click(function (e) {
        e.preventDefault();
        $('.tab__item').hide();
        var d_activeTab = $(this).attr('href');
        $(d_activeTab).fadeIn();
        $('html, body').animate({
            scrollTop: $(d_activeTab).offset().top
        }, 500);

        $('.tab__item__heading').removeClass('active');
        $(this).parent().addClass('active');

        // $('ul.tabs li').removeClass('active');
        // $('ul.tabs li[href^='"+d_activeTab+"']').addClass('active');
    });

    // Easy tabs

    $('.js-easy-tabs').easytabs({
        updateHash: true
    });

    /*------------------------------------*\
        $WOOCOMMERCE
    \*------------------------------------*/

    $('body').on('added_to_cart', function () {
        $('.menu-item--cart').addClass('menu-item--active');
    });

    // Quantity buttons

    // Rounding function

    function ceilNumber(num, factor = 1) {
        var quotient = num / factor;
        var res = Math.ceil(quotient) * factor;
        return res;
    }

    // Floor function

    function floorNumber(num, factor = 1) {
        var quotient = num / factor;
        var res = Math.floor(quotient) * factor;
        return res;
    }

    // Decrease

    $(document).on('click', '.quantity__increment--down', function () {
        var inputField = $(this).parent().find('input');
        var step = inputField.attr('step');
        var min = inputField.attr('min');
        var inputValue = parseInt(inputField.val());
        var count = parseInt(inputField.val()) - parseInt(step);

        if (inputField.data('rule') == 'wholesale') {
            console.log('Wholesale rules applied');
            // If not rounded, round down
            if (inputValue % step == 0) {
                count = parseInt(inputField.val()) - parseInt(step);
            } else {
                count = floorNumber(inputValue, step);
            }
        }

        count = count < min ? min : count; // If less than minimum, use the minimum, or else use the count
        inputField.val(count);
        inputField.change();
        $('div.woocommerce > form input[name="update_cart"]').prop('disabled', false);
        return false;
    });

    // Increase

    $(document).on('click', '.quantity__increment--up', function () {
        var inputField = $(this).parent().find('input');
        var step = inputField.attr('step');
        var min = inputField.attr('min');
        var inputValue = parseInt(inputField.val());
        var count = parseInt(inputField.val()) + parseInt(step);

        if (inputField.data('rule') == 'wholesale') {
            console.log('Wholesale rules applied');
            // If not rounded, round down
            if (inputValue % step == 0) {
                count = parseInt(inputField.val()) + parseInt(step);
            } else {
                count = ceilNumber(inputValue, step);
            }
        }

        inputField.val(count);
        inputField.change();
        $('div.woocommerce > form input[name="update_cart"]').prop('disabled', false);
        return false;
    });

    // Custom WooCommerce form elements

    function customWooCommerce() {

        $('#shipping_method li .shipping_method:checked').closest('li').addClass('is-checked');
        $('#shipping_method[data-count="1"] li').addClass('is-checked');

        $('.cart_totals #shipping_method li label').prepend('<span class="custom-radio"></span>');
        $('.checkout #shipping_method > li label').prepend('<span class="custom-radio"></span>');
        $('.wc_payment_methods > li > label').each(function () {
            $(this).prepend('<span class="custom-radio"></span>');
        });

        $('#ship-to-different-address label').append('<span class="custom-checkbox"></span>');
        $('.wc-terms-and-conditions label').append('<span class="custom-checkbox"></span>');
        $('.woocommerce-form-login .woocommerce-form__label-for-checkbox').append('<span class="custom-checkbox"></span>');
        $('.woocommerce-terms-and-conditions-wrapper input[type="checkbox"]').after('<span class="custom-checkbox"></span>');

        $('.woocommerce-account-fields .create-account').addClass('custom-checkbox__wrapper');
        $('.woocommerce-account-fields .create-account input[type="checkbox"]').after('<span class="custom-checkbox"></span>');

        $('.kl_newsletter_checkbox_field input').after('<span class="custom-checkbox"></span>');

        // Payment method icons

        $('.wc_payment_method').each(function () {
            var hasImage = $(this).find('label').find('img').length;
            if (hasImage) {
                $(this).addClass('wc_payment_method--icon');
            }
        });

        // YITH Account Funds - Partial Payment
        var partialPaymentAmount = $('#ywf_partial_payment .amount').text();
        if (partialPaymentAmount) {
            console.log('partialPaymentAmount: ' + partialPaymentAmount);
            $('#ywf_partial_payment').text('Apply Your Return Balance (' + partialPaymentAmount + ')');
        }

    }

    customWooCommerce();

    // Call again once cart is updated

    $(document.body).on('updated_cart_totals', function () {
        customWooCommerce();
        wholesaleQuantity();
    });

    // Call again when checkout is updated

    $(document).on('updated_checkout', function () {
        customWooCommerce();
        // Update duplicated order summary
        // Product Price
        $('#checkout-order-review .product-total').each(function () {
            var trueProductPrice = $(this).find('.amount').html();
            var productID = $(this).attr('id');
            $('.cart-collaterals li[data-id="' + productID + '"] .price').html(trueProductPrice);
        });
        // Tax
        if ($('#checkout-order-review .tax-rate').length) { // Itemized
            var trueTax = $('#checkout-order-review .tax-rate').html();
            if (trueTax) {
                $('.cart-collaterals .tax-rate').html(trueTax);
            } else {
                $('.cart-collaterals .tax-total,.cart-collaterals .tax-rate').empty();
            }
        } else { // Total
            var trueTax = $('#checkout-order-review .tax-total').html();
            if (trueTax) {
                $('.cart-collaterals .tax-total').html(trueTax);
            } else {
                $('.cart-collaterals .tax-total,.cart-collaterals .tax-rate').empty();
            }
        }
        // Shipping
        var shippingSelected = $('#checkout-order-review .woocommerce-shipping-totals .is-checked').length;
        var shippingDefault = $('#checkout-order-review .woocommerce-shipping-totals label').html();
        if (shippingSelected) {
            var trueShipping = $('#checkout-order-review .woocommerce-shipping-totals .is-checked label').html();
        } else {
            var trueShipping = $('#checkout-order-review .woocommerce-shipping-totals .no-shipping-text').text();
        }
        $('.cart-collaterals .shipping-amount td').html(trueShipping);
        // Subtotal
        var trueSubTotal = $("#checkout-order-review .cart-subtotal").html();
        $('.cart-collaterals .cart-subtotal').html(trueSubTotal);
        // Total
        var trueTotal = $("#checkout-order-review .order-total").html();
        $('.cart-collaterals .order-total').html(trueTotal);
    });

    // Wholesale Price - Add prefix text to price

        var priceLabel = 'RRP';
        if($('body').hasClass('site-id-1')) {
            priceLabel = 'MSRP';
        }

        if ($('body').hasClass('logged-in-trade')) {        
            $('.mega-menu .card__item .original-computed-price, .mega-menu .card__item .original-price, .card--product .card__item .original-computed-price, .card--product .card__item .original-price, .hero__item .original-computed-price, .hero__item .original-price').prepend('<span class="wholesale_price_title wholesale_price_title_original">' + priceLabel + ': </span>');
        }

    // WooCommerce - Variation Functions

    $('body').on('show_variation', function (event, variation) {

        // Price labels for trade
        if ($('body').hasClass('logged-in-trade')) {
            $('.single_variation .original-computed-price').append('<span class="wholesale_price_title wholesale_price_title_original">' + priceLabel + '</span>');
        }

        // Variable description
        variationDescription = variation.variation_description;
        variationSize = variation.attributes.attribute_pa_size;
        variationDiagram = variation.variation_size_diagram;
        variationSKU = variation.sku;        

        if (variationDescription) {
            $('#variation-data-description').html(variationDescription);
        } else {
            $('#variation-data-description').empty();
        }

        if (variationDiagram) {
            diagramLink = site_data.home_uri + '?p=' + variationDiagram;
            $('#variation-data-diagram').html('<a class="js-magnific-ajax" href="' + diagramLink + '">View set diagram');
        } else {
            $('#variation-data-diagram').empty();
        }

        // Update SKU

        if(variationSKU) {
            console.log('Variation SKU: ' + variationSKU);
            $('#single-product-sku').text(variationSKU);
        }

        // Add class for wholesale
        if ($('.product__price .wholesale_price_container').length) {
            $('.woocommerce-variation-wrapper').addClass('woocommerce-variation-price--wholesale');
        }
    });

    /*------------------------------------*\
        $FACET
    \*------------------------------------*/

    $(document).on('facetwp-refresh', function () {
        // $('html, body').animate({ scrollTop: $('.facet-top').offset().top }, 500);
        $('.facetwp-template').removeClass('facetwp-template--loaded');
        $('.facetwp-template').addClass('facetwp-template--loading');
        $('.facetwp-template').before('<div class="spinner spinner--dark"></div>');

        if ($('.faq').length) {
            if (FWP.loaded) {
                $('.faq__search__content').slideDown();
            }
        }

        $('.js-close-facet').click(function (e) {
            e.preventDefault();
            $('.faq__search__content').slideUp();
        });

    });

    $(document).on('facetwp-loaded', function () {

        // Scroll back to top
        //$('html, body').animate({ scrollTop: $('.facet-top').offset().top }, 500);

        if (FWP.loaded) {
            $('html, body').animate({
                scrollTop: $('.facet-top').offset().top
            }, 500);
        }

        $(".facetwp-sort select").dropkick({
            mobile: true,
            // change: function () {
            //  FWP.refresh();
            // }
        });

        $('.facetwp-template').removeClass('facetwp-template--loading');
        $('.facetwp-template').addClass('facetwp-template--loaded');
        $('.facetwp-template').prev('.spinner').fadeOut().remove();

        if ($('.facet-map').length) {
            $('.facet-map').addClass('is-loaded');
            $('.facet-map .spinner').fadeOut().remove();
            
            // Show/hide map markers

                var locationInput = $('.facetwp-location').val().length;
                var locationSearchInput = $('.facetwp-search').val().length;
                
                if(locationInput > 0 || locationSearchInput > 0) {
                    console.log('Location entered');
                    $('.facet-map').addClass('is-ready');
                    $('.facet-map').attr('data-search', true);
                    $('.facet-map__overlay').hide();
                } else {
                    $('.facet-map').attr('data-search', false);
                    $('.facet-map__overlay').show();
                }
        }

        var bLazy = new Blazy({
            selector: '.b-lazy',
            loadInvisible: true,
            offset: 200,
            success: function (element) {
                $(element).prev('.spinner').fadeOut().remove();
            }
        });
        // Timeout Applied by Sam because swatches were getting cut off
        setTimeout(function () {
            initMatchHeight();
        }, 1000);

        // Flyout

        FWP.hooks.addAction('facetwp/flyout/open', function () {
            if ($('.facetwp-flyout-close h4').length == 0) {
                $('.facetwp-flyout-close').empty().append('<h4 class="heading--line heading--line--beige"><span>Filter Options</span></h4>');
            }
            if ($('.flyout__footer').length == 0) { // If this content has not already been added           
                // Add footer with buttons
                $('.facetwp-flyout-content').append('<div class="flyout-row flyout__footer"><button class="button js-flyout-close">Apply filters</button><button class="js-flyout-reset facetwp-reset"><i class="fa-regular fa-rotate-left" aria-hidden="true"></i><span>Reset</span></button></div>');
            }
        });

        $(document).on('click', '.js-flyout-close', function () {
            FWP.flyout.close();
        });

        $(document).on('click', '.js-flyout-reset', function () {
            FWP.reset();
            FWP.flyout.close();
        });
    });

    /*------------------------------------*\
        $FUNCTIONS
    \*------------------------------------*/

    showFilter();

    // Scroll filters on mobile

    // $('.js-scroll-filter').click(function(e){
    //  var scrollingNav = $(this).parent().next().find('ul');
    //  e.preventDefault();
    //  console.log('Click');
    //  scrollingNav.addClass('scrolled');
    //  scrollingNav.scrollLeft('+=500');
    // });

    /*------------------------------------*\
        $CALCULATOR
    \*------------------------------------*/

    // If we are on the US site, change the calculator to use the Imperial system

    if ($('body').hasClass('site-id-1')) {
        setTimeout(function () {
            $('#measurement_select').val('Imperial').trigger('change');
            if($('#measurement_select').length) {
                var DKUoM = new Dropkick('#measurement_select');
                DKUoM.refresh();
            }
            if ($('body').hasClass('logged-in-trade') || $('body').hasClass('logged-in-wholesale')) {
                $('#pattern-repeat').val($('#pattern-repeat').data('in'));
            }
        }, 300);
    }

    /*------------------------------------*\
        $REVIEW
    \*------------------------------------*/

    $('a[href="#write-review"]').click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('#review-content').offset().top
        }, 1000);
        $('input.write-review-button').trigger('click');
    });


    /*------------------------------------*\
        $DETECT GOOGLEBOT
    \*------------------------------------*/

    if (navigator.userAgent.indexOf("Googlebot") != -1) {
        // console.log ("User is a Googlebot.");
    }

    // Image download link

    function getDownloadLink(downloadLink) {
        if(downloadLink) {
            var downloadExt = downloadLink.substr(downloadLink.lastIndexOf('.') - 4);
            var downloadWebP = downloadExt.includes('webp');
            if (downloadWebP) {
                downloadLink = downloadLink.slice(0, -5);
            }
            $('.js-download-image').attr('href', downloadLink);
        }        
    }

    if ($('.woocommerce-product-gallery').length) {
        $('.woocommerce-product-gallery').flexslider({
            start: function () {
                setTimeout(function () {
                    var downloadLink = $('.woocommerce-product-gallery__wrapper div').first().find('a').attr('href');
                    if(downloadLink) {
                        getDownloadLink(downloadLink);
                    } 
                    // Thumbnail slider
                    $('.product__media .flex-control-nav').on('init', function(){
                        $(this).css('opacity', 1);
                        $(this).css('overflow','visible');
                        $(this).css('min-height','auto');
                    });
                    $('.product__media .flex-control-nav').slick({
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        infinite: false,
                        arrows: true,
                        prevArrow: '<button class="slick-arrow slick-arrow--previous" type="button"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.1381 3.13814L6.27627 8.00001L11.1381 12.8619C11.3985 13.1222 11.3985 13.5443 11.1381 13.8047C10.8778 14.065 10.4557 14.065 10.1953 13.8047L4.86199 8.47136C4.60163 8.211 4.60163 7.7889 4.86199 7.52854L10.1953 2.19521C10.4557 1.93485 10.8778 1.93485 11.1381 2.19521C11.3985 2.45557 11.3985 2.87766 11.1381 3.13802V3.13814Z" fill="currentColor"/></svg></button>',
                        nextArrow: '<button class="slick-arrow slick-arrow--next" type="button"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.86187 3.13814L9.72373 8.00001L4.86187 12.8619C4.60151 13.1222 4.60151 13.5443 4.86187 13.8047C5.12223 14.065 5.54432 14.065 5.80468 13.8047L11.138 8.47136C11.3984 8.211 11.3984 7.7889 11.138 7.52854L5.80468 2.19521C5.54432 1.93485 5.12223 1.93485 4.86187 2.19521C4.60151 2.45557 4.60151 2.87766 4.86187 3.13802V3.13814Z" fill="currentColor"/></svg></button>',
                        focusOnSelect: true,
                        dots: false
                    });
                }, 1000);
            }
        });
    }

    setTimeout(function(){
        // Slider
        var productSlider = $('.woocommerce-product-gallery').data('flexslider');

        // On change
        if (productSlider) {
            productSlider.vars.after = function () {
                var downloadLink = $('.woocommerce-product-gallery__wrapper .flex-active-slide a').attr('href');
                if(downloadLink) {
                    getDownloadLink(downloadLink);
                }            
            };
        }
    }, 1000);   

    // Reset widget filters (query string)

    function resetWidgetFilter() {
        window.location = window.location.href.split("?")[0];
    }

    $('.js-reset-filter').click(function () {
        resetWidgetFilter();
    });

    // Open live chat from URL

    var hash = decodeURIComponent(location.hash.substr(1));
    if (hash) {
        console.log(hash);
        if ('chat' == hash) {
            purechatApi.on('chatbox:ready', function () {
                purechatApi.set('chatbox.expanded', true); // Expanded the chat box (false collapses it)
            });
        }
        if ('search' == hash) {
            if (Modernizr.mq('only screen and (min-width: 1200px)')) {
                setTimeout(function () {
                    $('.header__search input[type="search"]').focus();
                }, 300);
            } else if (Modernizr.mq('only screen and (max-width: 767px)')) {
                setTimeout(function () {
                    $('.header .js-search-focus-autocomplete').trigger('click');
                    $('.header__search input[type="search"]').focus();
                }, 300);
            }
        }
    }

    // Product page - add swatch name

    $('#picker_pa_color').append('<div class="swatch-label-wrap">Selected: <span class="swatch-label"></span></div>');
    $('#picker_pa_colour').append('<div class="swatch-label-wrap">Selected: <span class="swatch-label"></span></div>');

    // Tooltip

    $('body').on('mouseenter', '.woocommerce-variation-price.has-tooltip', function () {
        $(this).parent('div').find('.tooltip').addClass('tooltip--active');
    });

    $('body').on('mouseleave', '.woocommerce-variation-price.has-tooltip', function () {
        $(this).parent('div').find('.tooltip').removeClass('tooltip--active');
    });

    // Open first accordion on load

    $('.single-product .product__text .accordion__item__heading').first().trigger('click');

    // Lazy loading product archive

    $('.js-gallery-mini').each(function(){
        $(this).find('.slick-item').first().addClass('is-active');
        var firstImage = $(this).find('.slick-item').first().find('img');
        var firstImageURL = firstImage.data('lazy');
        firstImage.attr('src', firstImage.data('lazy'));
        // $(this).find('.spinner').fadeOut().remove();

        var slickActive = $(this).find('.slick-item').first();
        var newURL = slickActive.data('url');
        var slickID = slickActive.data('parent');
        $('a[data-id="' + slickID + '"]').attr('href', newURL);
    });

    $('.js-swap-thumb').each(function(){
        var firstItem = $(this).find('li:first');
        var firstItemParent = firstItem.data('parent');
        var firstItemID = firstItem.attr('id');
        firstItem.addClass('is-active');
        // Update swatchbook ID
        $('[data-id="' + firstItemParent + '"] .js-makcs-add-variation').attr('data-id',firstItemID);
    });

    $('.js-swap-thumb li').click(function(e) {
        e.preventDefault();
        var slide = $(this).data('index');
        var parent = $(this).data('parent');
        console.log(parent);
        //$('#slick-' + parent).slick('slickGoTo', slide);      
        var targetID = $(this).attr('id');
        console.log(targetID);
        var targetImage = $('#' + targetID).find('img');
        $(targetImage).attr('src', $(targetImage).data('lazy'));
        // Show current image
        $('#gallery-' + parent).find('.is-active').removeClass('is-active');
        $('#' + targetID).addClass('is-active');
        // Update thumbnail class
        $(this).siblings('li').removeClass('is-active');
        $(this).addClass('is-active');       
        // Update URL
        var slickActive = $('#' + targetID);
        var newURL = slickActive.data('url');
        var slickID = slickActive.data('parent');
        $('a[data-id="' + slickID + '"]').attr('href', newURL);
        // Update swatchbook ID
        $('[data-id="' + parent + '"] .js-makcs-add-variation').attr('data-id',targetID);
        console.log('.js-slick-thumb: ' + parent + ' - ' + targetID);
    });

    // Howler.js

    // Functions

    function formatTime(secs) {
        var minutes = Math.floor(secs / 60) || 0;
        var seconds = (secs - minutes * 60) || 0;
        return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    }

    // Player

    $('.audio-player').each(function () {
        var audioPlayer = $(this);
        var audioFile = $(this).data('url');
        var button = $(this).find('.audio-player__control');
        var timer = $(this).find('.audio-player__timer');
        var circle = $(this).find('.circle');
        var bar = $(this).find('.bar');

        var sound = new Howl({
            src: [audioFile],
            html5: true, // Force to HTML5 so that the audio can stream in (best for large files).
            onload: function () {
                var duration = sound.duration();

                var tlCircle = new TimelineLite({ paused: true });
                tlCircle.to(bar, duration, { width: '100%' }, 0);

                function togglePlay() {
                    var isPlaying = sound.playing();
                    var duration = sound.duration();

                    if (isPlaying) {
                        sound.pause();
                        button.attr('data-state', 'pause');
                        audioPlayer.removeClass('is-active');
                        tlCircle.pause();
                    } else {
                        sound.play();
                        button.attr('data-state', 'play');
                        audioPlayer.addClass('is-active');
                        tlCircle.play();
                    }
                }

                button.click(function () {
                    togglePlay();
                });
            },
            onplay: function () {
                function updateTimeTracker(elem) {
                    var self = $(this);
                    var seek = sound.seek() || 0;
                    var currentTime = formatTime(Math.round(seek));

                    timer.text(currentTime);

                    if (sound.playing()) {
                        requestAnimationFrame(updateTimeTracker.bind(self));
                    }
                }
                requestAnimationFrame(updateTimeTracker.bind($(this)));
            }
        });

    });

    // Layout toggle

    $('.js-change-layout button').click(function (e) {
        e.preventDefault();
        var layout = $(this).data('layout');
        if (layout == 'grid') {
            $('#layout').removeClass('directory--list');
            $('#layout').addClass('directory--grid');
        } else {
            $('#layout').removeClass('directory--grid');
            $('#layout').addClass('directory--list');
        }
        $('.js-change-layout button').removeClass('is-active');
        $(this).addClass('is-active');
    });

    // Map toggle

    $('.js-toggle-map button').click(function (e) {
        var layout = $(this).data('layout');
        var parent = $('.facet-parent');
        var list = $('.facet-view--list');
        var map = $('.facet-view--map');
        var listHeight = list.outerHeight();
        var mapHeight = map.outerHeight();
        $('.js-toggle-map button').removeClass('is-active');
        $(this).addClass('is-active');
        if (layout == 'list') {
            map.addClass('is-invisible');
            list.removeClass('is-invisible');
        } else {
            list.addClass('is-invisible');
            map.removeClass('is-invisible');
            FWP_MAP.map.fitBounds(FWP_MAP.bounds);
        }
    });

    // Sticky element

    if ($('#taxonomy-filter').length) {
        var observer = new IntersectionObserver(function (entries) {
            // no intersection 
            if (entries[0].intersectionRatio === 0)
                document.querySelector("#taxonomy-filter").classList.add("is-sticky");
            // fully intersects 
            else if (entries[0].intersectionRatio === 1)
                document.querySelector("#taxonomy-filter").classList.remove("is-sticky");
        }, {
            threshold: [0, 1]
        });
        observer.observe(document.querySelector("#taxonomy-filter-top"));
    }

    // Searchspring - search form

    $('.search-autocomplete-view input').focus(function () {
        $('.search-autocomplete-clear').addClass('active');
        $('[ss-autocomplete]').addClass('is-active');
    });

    $('.search-autocomplete-clear').click(function (e) {
        e.preventDefault();
        $('[ss-autocomplete]').removeClass('is-active');
        $(this).removeClass('active');

        if ($('.header__search').hasClass('is-active')) {
            $('.header__search').removeClass('is-active');
        }
    });

    // Toggle

    $('.js-search-focus-autocomplete').click(function () {
        $('.header__search').addClass('is-active');
        $('#Search').focus();
        $('.search-autocomplete-clear').addClass('active');
        // $('[ss-autocomplete]').addClass('is-active');
    });

    // Taxonomy toggle

    $('.taxonomy__header__toggle').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('is-active');
        $('.taxonomy__intro').slideToggle();
    });

    // Klaviyo - Cookies

    document.cookie = "__kla_off=true";

    // Theme variables

    const themeData = [
        ["Theme URI", site_data.theme_uri],
        ["Home URI", site_data.home_uri],
        ["Wallpaper ID", site_data.wallpaper_slug],
        ["Wholesale Sample Message", site_data.wholesale_sample_message],
        ["Wholesale Sample Minimum", parseInt(site_data.wholesale_sample_min)],
        ["Wholesale Sample Step", parseInt(site_data.wholesale_sample_step)]
    ];
    //console.table(themeData);

    // WooCommerce - Check Variations

    $('body').on('check_variations', function () {
        wholesaleQuantity();
    });

    // Wholesale - Minimum Quantity

    function wholesaleQuantity() {
        // Conditional check for user role
        if ($('body').hasClass('logged-in-wholesale')) {
            // Product
            if ($('.single-product').length) {
                var size = $('#pa_size').val();
                var qty = $('.quantity-input input.qty');
                var material = $('.product').data('material-type');
                var minQty = parseInt(site_data.wholesale_sample_min);
                var stepQty = parseInt(site_data.wholesale_sample_step);
                var minMessage = site_data.wholesale_sample_message
                // console.log('Size: ' + size + '. Material: ' + material);
                if (material == 'wallpaper') {
                    if (size == 'sample') {
                        console.log('Apply wholesale minimum quantity rules: ' + minQty + ' / ' + stepQty);
                        qty.val(minQty);
                        qty.attr('step', stepQty);
                        qty.attr('min', minQty);
                        qty.attr('data-rule', 'wholesale');
                        $('#variation-data-wholesale').html(minMessage);
                    } else {
                        console.log('Reset quantity rules');
                        qty.val(1);
                        qty.attr('step', 1);
                        qty.attr('min', 1);
                        qty.attr('data-rule', 'none');
                        $('#variation-data-wholesale').empty();
                    }
                }
            }

            // Cart 
            if ($('.woocommerce-cart-form').length) {
                $('.woocommerce-cart-form__cart-item').each(function () {
                    var qty = $(this).find('.cart-quantity input');
                    var size = $(this).data('variation-size');
                    var material = $(this).data('variation-material');
                    var minQty = parseInt(site_data.wholesale_sample_min);
                    var stepQty = parseInt(site_data.wholesale_sample_step);
                    if (material == 'wallpaper' && size == 'sample') {
                        qty.attr('step', stepQty);
                        qty.attr('min', minQty);
                        qty.attr('data-rule', 'wholesale');
                    }
                });
            }
        }

    }

    wholesaleQuantity();



});

/*------------------------------------*\
    $GRAVITY FORMS
\*------------------------------------*/

$(document).bind('gform_post_render', function () {

    $('.has-form .spinner').fadeOut().remove();

    $('.gform_wrapper').removeClass('form--loading');

    $('.gfield_select').dropkick({
        mobile: true
    });

    // Gravity forms custom elements

    var GFSelect = $('.ginput_container_select select');
    var GFCheckbox = $('.gfield_checkbox li label, .gfield_checkbox .gchoice label');
    var GFRadio = $('.gfield_radio li label, .gfield_radio .gchoice label');
    var GFDate = $('.ginput_container_date input');

    // GFSelect.each(function(){
    //  if(!$(this).parent().hasClass('custom-select')) {
    //      $(this).wrap('<div class="custom-select"></div>');
    //  }
    // });

    GFCheckbox.each(function () {
        if (!$(this).prev('.custom-checkbox').length) {
            $(this).prepend('<span class="custom-checkbox"></span>');
        }
    });

    GFRadio.each(function () {
        if (!$(this).prev('.custom-radio').length) {
            $(this).prepend('<span class="custom-radio"></span>');
        }
    });

    GFDate.each(function () {
        if (!$(this).parent().hasClass('custom-datepicker')) {
            $(this).wrap('<div class="custom-datepicker"></div>');
        }
    });

    // $('.ginput_container_select select').wrap("<div class='custom-select'></div>");
    // $('.gfield_checkbox li label').prepend("<span class='custom-checkbox'></span>");
    // $('.gfield_radio li label').prepend("<span class='custom-radio'></span>");
    // $('.ginput_container_date input').wrap("<div class='custom-datepicker'></div>");

    // Remove error messages after field is filled out again

    $('.gfield_error').each(function(){
        var parent = $(this);
        var inputField = $(this).find('input, textarea');
        var errorMessage = $(this).find('.validation_message');
        inputField.on('focus', function(){
            parent.removeClass('gfield_error');
            errorMessage.css('opacity',0);
        });
    });

    // Assign 'region' to country

    $('.js-country-field select').on('change', function(){
        var selectedCountry = $(this).val();
        var regionField = $('.js-country-region input');
        console.log('Country dropdown changed to ' + selectedCountry); 
        var regionAmerica = ['Anguilla','Antigua and Barbuda','Argentina','Aruba','Bahamas','Barbados','Belize','Bermuda','Bolivia','Brazil','British Virgin Islands','Canada','Cayman Islands','Chile','Colombia','Costa Rica','Cuba','Dominica','Dominican Republic','Ecuador','El Salvador','Falkland Islands','Grenada','Guadeloupe','Guatemala','Guyana','Haiti','Honduras','Jamaica','Martinique','Mexico','Montserrat','Nicaragua','Panama','Paraguay','Peru','Puerto Rico','Saint Barthélemy','Saint Kitts and Nevis','Saint Lucia','Saint Martin','Saint Pierre and Miquelon','Saint Vincent and the Grenadines','Suriname','Trinidad and Tobago','Turks and Caicos Islands','U.S. Virgin Islands','United States','Uruguay','Venezuela','U.S. Minor Outlying Islands'];
        var regionAustralasia = ['Fiji','Kiribati','Marshall Islands','Micronesia','Nauru','Palau','Papua New Guinea','Samoa','Solomon Islands','Tonga','Tuvalu','Vanuatu','American Samoa','Bangladesh','Bhutan','Bouvet Island','British Indian Ocean Territory','Brunei','Cambodia','China','Cocos [Keeling] Islands','Cook Islands','French Polynesia','French Southern Territories','Guam','Heard Island and McDonald Islands','Hong Kong SAR China','India','Indonesia','Japan','Kazakhstan','Kyrgyzstan','Laos','Macau SAR China','Malaysia','Maldives','Mongolia','Myanmar [Burma]','Nepal','Netherlands Antilles','New Caledonia','Niue','Norfolk Island','North Korea','Northern Mariana Islands','Pakistan','Philippines','Pitcairn Islands','Réunion','Saint Helena','Singapore','South Georgia and the South Sandwich Islands','South Korea','Sri Lanka','Taiwan','Tajikistan','Thailand','Timor-Leste','Tokelau','Turkmenistan','Uzbekistan','Vietnam','Wallis and Futuna'];
        var regionEurope = ['Algeria','Angola','Belarus','Benin','Botswana','Burkina Faso','Burundi','Cameroon','Cape Verde','Central African Republic','Chad','Comoros','Congo - Brazzaville','Congo - Kinshasa','Côte d’Ivoire','Djibouti','Equatorial Guinea','Eritrea','Ethiopia','Gabon','Gambia','Ghana','Guinea','Guinea-Bissau','Isle of Man','Jersey','Kenya','Lesotho','Liberia','Libya','Madagascar','Malawi','Mali','Mauritania','Mauritius','Morocco','Mozambique','Namibia','Niger','Nigeria','Rwanda','Senegal','Seychelles','Sierra Leone','Somalia','South Africa','Sudan','Svalbard and Jan Mayen','São Tomé and Príncipe','Tanzania','Togo','Tunisia','Uganda','Ukraine','Zambia','Zimbabwe','Åland Islands','Faroe Islands','Mayotte','Swaziland','Western Sahara'];
        var regionMiddleEast = ['Afghanistan','Armenia','Azerbaijan','Bahrain','Egypt','Georgia','Iran','Iraq','Israel','Jordan','Kuwait','Lebanon','Oman','Palestinian Territories','Qatar','Saudi Arabia','Syria','Turkey','United Arab Emirates','Yemen'];
        if ($.inArray(selectedCountry, regionAmerica) !== -1) {
            regionField.val('America');
        } else if ($.inArray(selectedCountry, regionAustralasia) !== -1) {
            regionField.val('Australasia');
        } else if ($.inArray(selectedCountry, regionEurope) !== -1) {
            regionField.val('Europe');
        }  else if ($.inArray(selectedCountry, regionMiddleEast) !== -1) {
            regionField.val('Middle East');
        }
    });

});

$(window).resize(function () {
    showFilter();
});

// Photoswipe for post images

$('body').on('click', '.project figure img', function (e) {
    e.stopPropagation(); // Prevent event bubbling to the parent .project element

    var pswpElement = $('.pswp')[0],
        items = [],
        project = $(this).closest('.project');

    project.find('figure').each(function () {
        var figure = $(this),
            img = figure.find('img');

        if (img.length) {
            items.push({
                alt: img.attr('alt'),
                src: img.attr('src'),
                w: img.prop('naturalWidth'),
                h: img.prop('naturalHeight'),
                title: figure.find('figcaption').text() || ''
            });
        }
    });

    if (items.length === 0) return false;

    var options = {
        index: project.find('figure img').index($(this)),
        addCaptionHTMLFn: function (item, captionEl) {
            if (!item.title) {
                captionEl.children[0].textContent = '';
                return false;
            }
            captionEl.children[0].textContent = item.title;
            return true;
        },
        shareEl: false
    };

    var photoswipe = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    photoswipe.init();
});

// Lookbook - Photoswipe

$('body').on('click', '.lb__gallery__grid figure', function (e) {
    e.stopPropagation(); // Prevent event bubbling to the parent .project element

    var pswpElement = $('.pswp')[0],
        items = [],
        project = $(this).closest('.lb__gallery__grid');

    project.find('figure').each(function () {
        var figure = $(this),
            img = figure.find('img');

        if (img.length) {
            items.push({
                alt: img.attr('alt'),
                src: img.attr('src'),
                w: img.prop('naturalWidth'),
                h: img.prop('naturalHeight'),
                title: figure.find('figcaption').text() || ''
            });
        }
    });

    if (items.length === 0) return false;

    var options = {
        index: project.find('figure').index($(this)),
        addCaptionHTMLFn: function (item, captionEl) {
            if (!item.title) {
                captionEl.children[0].textContent = '';
                return false;
            }
            captionEl.children[0].textContent = item.title;
            return true;
        },
        shareEl: false
    };

    var photoswipe = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    photoswipe.init();
});

// SCROLL MAGIC

var controller = new ScrollMagic.Controller({
    // globalSceneOptions: {
    // 	triggerHook: "onEnter" // Trigger elements when they appear
    // }
});

// BADGE

TweenMax.to('.badge .rotate', 40, { rotation: 360, transformOrigin: '50% 50%', ease:Linear.easeNone, repeat: -1 });

// CART

var A = $('.menu-item--active svg');
var tl = new TimelineMax({infinite: true});

tl.to(A, 0.5, { y: '+=5px' });
tl.to(A, 0.5, { y: '-=5px' });
tl.to(A, 0.5, { y: '0' });

// PARALLAX

$('.anim-parallax').each(function(index,elem){
    $item = $(this);

    //var Tween = TweenMax.to($item, { y: '80%', ease: Linear.easeNone });

    var sceneItem = new ScrollMagic.Scene({
        triggerHook: 'onEnter',
        duration: '200%',
        triggerElement: elem,
        reverse: true,
        offset: 200
    })
    .setTween($item, { y: '-50%', ease: Linear.easeNone })
    .addTo(controller);
});

// OVERLAPPING CARDS

if($('.hero-slider').length) {

    var trigger = '.header';
    var A = $('.card--overlap .card__item');
    var B = $('.card--overlap .card__item__footer');
    var C = $('.card--overlap .card__item__image');
    var D = $('.card--overlap .card__item__image .overlay');

    var tween = new TimelineMax()
    .to(A, 0.5, { opacity: 1, x: 0, ease: Power1.easeOut })
    .to(B, 0.5, { opacity: 1, x: 0, ease: Power1.easeOut })
    .to(C, 0.5, { opacity: 1, y: 0, ease: Power1.easeOut })
    .to(D, 0.5, { width: 0, ease: Sine.easeOut });

    var scene = new ScrollMagic.Scene({
        triggerElement: trigger,
        triggerHook: 0,
    })
    .setTween(tween)
    .addTo(controller);

}

// MEDIA

if($('.content--review').length) {

    var trigger = '.content--review';
    var A = $('.media__text');
    var B = $('.media__media');
    var C = $('.media__footer');
    var D = $('.media .overlay');
    var E = $('.review');

    var tween = new TimelineMax()
    .to(A, 0.5, { opacity: 1, x: 0, ease: Power1.easeOut })
    .to(B, 0.5, { opacity: 1, y: 0, ease: Power1.easeOut })
    .to(C, 0.5, { opacity: 1, x: 0, ease: Power1.easeOut })
    .to(D, 0.5, { width: 0, ease: Sine.easeOut })
    .to(E, 0.5, { opacity: 1, y: 0, ease: Power1.easeOut });

    var scene = new ScrollMagic.Scene({
        triggerElement: trigger,
    })
    .setTween(tween)
    .addTo(controller);

}

// HERO SCROLLER

if($('.hero-scroller').length) {

    var trigger = '.hero-scroller';
    var A = $('.hero-scroller__item');
    var B = $('.hero-scroller__item .hero__item__content');
    var tl = new TimelineMax();
    tl.add([
        TweenMax.staggerTo(A, 0.5, { opacity: 1, className:"+=is-active" }, 1),
        TweenMax.staggerTo(B, 0.5, { opacity: 1, scale: 1, y: 1 }, 1)
    ]);

    var scene = new ScrollMagic.Scene({
        triggerElement: trigger,
        duration: '200%',
        triggerHook: 0,
        reverse: true
    })
    .setPin(trigger)
    .setTween(tl)
    .addTo(controller);

}

// SCROLL CUE

var A = $('.hero-scroller .scroll-cue');

var tl = new TimelineMax({ repeat: -1, repeatDelay: 0.5 })
.to(A, 1, { y: '12', ease: Power1.easeNone })
.to(A, 0.2, { y: '0', ease: Power1.easeOut })
.to(A, 0.2, { y: '8', ease: Power1.easeNone })
.to(A, 0.4, { y: '0', ease: Power1.easeOut });

// HAND

if($('.content--review').length) {

    var A = $('.content--review');
    var B = $('.support');
    var C = A.height() - B.height(); // Heigh of container - height of element

    var scene = new ScrollMagic.Scene({
        triggerElement: '.content--review',
        triggerHook: 0,
        duration: C
    })
    .on('enter', function(e) {
        if (e.target.controller().info('scrollDirection') == 'FORWARD') {
            B.addClass('support--active');
        } else {
            B.addClass('support--active');
            B.removeClass('support--static');
        }
    })
    .on('leave', function(e) {
        if (e.target.controller().info('scrollDirection') == 'FORWARD') {
            B.addClass('support--static');
            B.removeClass('support--active');
        } else {
            B.removeClass('support--active');
        }
    })
    .addTo(controller);

}

// Updated functions

    // Ticker - Text
    
        $('.js-text-ticker ul').each(function(){
            var parent = $(this).parent('div');
            $(this).clone().appendTo(parent);
            $(this).clone().appendTo(parent);
        });

        var speed = 30;
        var tickerWidth = $(".js-text-ticker ul").width();
        var initDuration = tickerWidth / speed;

        gsap.to(".js-text-ticker ul", {
            duration: initDuration,
            xPercent: -100,
            ease: "none",
            repeat: -1
        });

    // Ticker - Image 

    $('.js-lp-image-ticker ul').each(function(){
            var parent = $(this).parent('div');
            $(this).clone().appendTo(parent);
        });
        var speed = 50;
        var tickerWidth = $(".js-lp-image-ticker ul").width();
        var initDuration = tickerWidth / speed;
        gsap.to(".js-lp-image-ticker ul", {
            duration: initDuration,
            xPercent: -100,
            ease: "none",
            repeat: -1
        });

// Footer Nav toggle

    $('.footer__nav__header').each(function(){
        $(this).click(function(e){
            e.preventDefault();
            $(this).next('.footer__nav__item').toggleClass('is-active');
        });
    });

// Swiper - Scroll

const swiperScroll = new Swiper('.js-swiper-scroll', {
    // Optional parameters
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 12,
    grabCursor: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
    },
    breakpoints: {
        // when window width is >= 320px
        768: {              
          spaceBetween: 24
        }
    }
});

// Swiper - Slideshow

    const swiperSlideshow = new Swiper('.js-swiper-slideshow', {
        // Optional parameters
        loop: true,
        effect: 'fade',
        fadeEffect: {
        crossFade: true
        },
        autoplay: {
        delay: 3000
        },
        speed: 1000
    });

// Swiper - Mobile only 

var init = false;
var swiperMobile;

function swiperCard() {
    if (window.innerWidth <= 1200) {
        if (!init) {
            init = true;
            swiperMobile = new Swiper(".js-swiper-mobile", {
                direction: "horizontal",
                slidesPerView: 1,                    
                spaceBetween: 24,
                scrollbar: {
                    el: '.swiper-scrollbar',
                },
            });
        }
    } else if (init) {
        swiperMobile.destroy();
        init = false;
    }
}

swiperCard();

window.addEventListener("resize", swiperCard);

// Custom attribute swatch display

    if($('.js-attribute-swatch').length) {
        // 1. Handle button click
        $(".js-attribute-swatch button").on("click", function () {
            var $button = $(this);
            var value = $button.data("value");
            var label = $button.data('label');
            var attributeName = $button.closest(".variation-buttons").data("attribute_name");

            console.log('Color value: ' + value);

            // 2. Update the hidden select and trigger change
            var $select = $("#pa_color");
            $select.val(value).trigger("change");

            // 3. Update button UI
            $(this).closest('ul').find('.selected').removeClass('selected');
            $button.addClass("selected");

            // Update label 
            $('.swatch-list-current span').text(label);
        });

        // 5. On page load, sync button selection with default <select> value
        $("#pa_color").each(function () {
            var $select = $(this);
            var value = $select.val();
            var name = $select.attr("name");
            var $buttons = $(".js-attribute-swatch[data-attribute_name='" + name + "']");

            $buttons.find(".variation-button").removeClass("selected");
            $buttons.find(".variation-button[data-value='" + value + "']").addClass("selected");
            var $selectedButton = $($buttons).find('button.selected');
            if ($selectedButton.length) {
                var selectedColorLabel = $selectedButton.data('label');
                $('.swatch-list-current span').text(selectedColorLabel);
            }
        });
    }  